import React, { useEffect, useMemo, useState } from "react";
import { HeaderPage } from "../../components/Admin";
import { ModalBasic } from "../../components/common";
import { useLeadsKanban } from "../../hook";
import { KanbanColumn } from "../../components/Admin/Leads";
import { DragDropContext } from "@hello-pangea/dnd";
import { moveLead } from "../../api/crm";
import { useAuth } from "../../hook";
import { LeadForm } from "../../components/Admin/Leads/LeadForm";

import { KanbanDateFilter } from "../../components/Admin/Leads/KanbanDateFilter";
import { buildKanbanParams } from "../../utils/dateRanges";

export function LeadsAdmin() {
  const { auth } = useAuth();

  // estado de filtro (lo alimenta el componente)
  const [dateFilter, setDateFilter] = useState({
    startDate: null,
    endDate: null,
    activeRange: "last7",
  });

  const kanbanParams = useMemo(() => {
    return buildKanbanParams(dateFilter.startDate, dateFilter.endDate);
  }, [dateFilter.startDate, dateFilter.endDate]);

  // ✅ ahora sí pasamos params
  const { stages, isLoading, isError, refresh } = useLeadsKanban(kanbanParams);

  const [board, setBoard] = useState([]);
  useEffect(() => { setBoard(stages || []); }, [stages]);

  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState(null);
  const [contentModal, setContentModal] = useState(null);
  const [sizeModal, setSizeModal] = useState(null);

  const openCloseModal = () => setShowModal((p) => !p);

  const onAddLead = () => {
    setTitleModal("Crear Lead");
    setContentModal(
      <LeadForm
        onClose={openCloseModal}
        onSaved={() => refresh()}
      />
    );
    setSizeModal("medium");
    openCloseModal();
  };


    // ✅ NUEVO: crear lead directo en una etapa
  const onAddLeadInStage = (stage) => {
    setTitleModal(`Crear Lead en: ${stage.name}`);
    setContentModal(
      <LeadForm
        defaultStageId={stage.id}   // 👈 nuevo prop
        onClose={openCloseModal}
        onSaved={() => refresh()}
      />
    );
    setSizeModal("medium");
    openCloseModal();
  };

  const onEditLead = (lead) => {
    setTitleModal(`Editar Lead #${lead.id}`);
    setContentModal(
      <LeadForm
        lead={lead}
        onClose={openCloseModal}
        onSaved={() => refresh()}
      />
    );
    openCloseModal();
  };

  const findColumnIndexByStageId = (arr, stageId) =>
    arr.findIndex((c) => String(c?.stage?.id) === String(stageId));

  const onDragEnd = async (result) => {
    const { draggableId, source, destination } = result;
    if (!destination) return;
    if (destination.droppableId === source.droppableId && destination.index === source.index) return;

    const nextBoard = structuredClone(board);
    const srcColIdx = findColumnIndexByStageId(nextBoard, source.droppableId);
    const dstColIdx = findColumnIndexByStageId(nextBoard, destination.droppableId);
    if (srcColIdx === -1 || dstColIdx === -1) return;

    const sourceLeads = Array.from(nextBoard[srcColIdx].leads);
    const [moved] = sourceLeads.splice(source.index, 1);
    nextBoard[srcColIdx].leads = sourceLeads;

    const destLeads = Array.from(nextBoard[dstColIdx].leads);
    destLeads.splice(destination.index, 0, moved);
    nextBoard[dstColIdx].leads = destLeads;

    const prevBoard = board;
    setBoard(nextBoard);

    const prevData = stages;
    refresh(nextBoard, { revalidate: false });

    try {
      const payload = {
        stage_id: Number(destination.droppableId),
        position: Number(destination.index),
      };
      await moveLead(draggableId, payload, auth?.token);
      refresh();
    } catch (err) {
      console.error(err);
      setBoard(prevBoard);
      refresh(prevData, { revalidate: false });
    }
  };

  const columns = useMemo(() => board || [], [board]);

  return (
    <>
      <HeaderPage title="Leads - vista Kanban" btnTitle="Crear Lead" btnClick={onAddLead} />

      {/* ✅ filtro UI (igual al dashboard) */}
      <KanbanDateFilter onChange={setDateFilter} defaultRangeKey="last7" />

      {isLoading && <p>Cargando...</p>}
      {isError && <p>Error cargando el tablero</p>}

      {!isLoading && !isError && (
        <DragDropContext onDragEnd={onDragEnd}>
          <div style={{ display: "flex", overflowX: "auto", padding: 8 }}>
            {columns.map((col) => (
              <KanbanColumn
                key={col.stage.id}
                stage={col.stage}
                leads={col.leads}
                onAddLead={onAddLeadInStage}
                onLeadClick={onEditLead}
              />
            ))}
          </div>
        </DragDropContext>
      )}

      <ModalBasic show={showModal} onClose={openCloseModal} title={titleModal} sizeModal={sizeModal}>
        {contentModal}
      </ModalBasic>
    </>
  );
}
